module.exports = __webpack_public_path__ + "static/media/success.b505102a.png";